"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const charDefs_1 = require("./charDefs");
const reverseString_1 = require("./utils/reverseString");
const tokens = {
    '0': {
        type: 'Number',
        pattern: /\d/,
    },
    A: {
        type: 'Letter',
        pattern: /[a-zA-Z]/,
    },
    S: {
        type: 'Alphanumeric',
        pattern: /[a-zA-Z0-9]/,
    },
    '*': {
        type: 'Any',
        pattern: null,
    },
    '[': {
        type: 'InitRecursive',
        pattern: null,
    },
    ']': {
        type: 'EndRecursive',
        pattern: null,
    },
    '{': {
        type: 'InitOptional',
        pattern: null,
    },
    '}': {
        type: 'EndOptional',
        pattern: null,
    },
    $: {
        type: 'Escape',
        pattern: null,
    },
};
class StringMask {
    constructor(options) {
        this.process = (strValue, options) => {
            var _a, _b, _c;
            let valuePos = 0;
            const { reverse, mask } = options;
            const processedChars = [];
            let isOptional = false;
            const value = reverse ? (0, reverseString_1.reverseStr)(strValue) : strValue;
            const maskChars = reverse ? (0, reverseString_1.reverseStr)(mask).split('') : mask.split('');
            const initRecursiveChar = reverse ? tokens[']'].type : tokens['['].type;
            const endRecursiveChar = reverse ? tokens['['].type : tokens[']'].type;
            for (let i = 0; i < mask.length; i++) {
                if (valuePos >= value.length) {
                    break;
                }
                switch ((_a = tokens[maskChars[i]]) === null || _a === void 0 ? void 0 : _a.type) {
                    case 'Number':
                    case 'Alphanumeric':
                    case 'Letter': {
                        if ((_b = tokens[maskChars[i]].pattern) === null || _b === void 0 ? void 0 : _b.test(value[valuePos])) {
                            processedChars.push(new charDefs_1.InputDef(value[valuePos]));
                            if (options.onProcessInputChar) {
                                options.onProcessInputChar(value[valuePos], valuePos);
                            }
                            valuePos++;
                        }
                        else {
                            if (isOptional) {
                                break;
                            }
                            for (let j = valuePos; j < value.length; j++) {
                                if (((_c = tokens[maskChars[i]].pattern) === null || _c === void 0 ? void 0 : _c.test(value[j])) === false) {
                                    if (options.onProcessInputChar) {
                                        options.onProcessInputChar(value[valuePos], valuePos);
                                    }
                                    valuePos++;
                                }
                                else {
                                    i--;
                                    break;
                                }
                            }
                        }
                        break;
                    }
                    case 'Any': {
                        processedChars.push(new charDefs_1.InputDef(value[valuePos]));
                        if (options.onProcessInputChar) {
                            options.onProcessInputChar(value[valuePos], valuePos);
                        }
                        valuePos++;
                        break;
                    }
                    case 'Escape': {
                        processedChars.push(new charDefs_1.FixedDef(maskChars[i + 1]));
                        if (options.onProcessFixedChar) {
                            options.onProcessFixedChar(maskChars[i + 1]);
                        }
                        i++;
                        break;
                    }
                    case initRecursiveChar: {
                        const recursiveMask = maskChars.slice(i + 1, maskChars.indexOf(endRecursiveChar));
                        while (valuePos < value.length) {
                            const recursiveValue = value.slice(valuePos);
                            const recursiveProcessedChars = this.process(recursiveValue, {
                                mask: recursiveMask.join(''),
                                onProcessInputChar: (char) => {
                                    if (options.onProcessInputChar) {
                                        options.onProcessInputChar(char, valuePos);
                                    }
                                    valuePos++;
                                },
                                onProcessFixedChar: (char) => {
                                    if (options.onProcessFixedChar) {
                                        options.onProcessFixedChar(char);
                                    }
                                },
                            });
                            processedChars.push(...recursiveProcessedChars);
                        }
                        break;
                    }
                    case 'InitOptional':
                    case 'EndOptional': {
                        isOptional = !isOptional;
                        break;
                    }
                    default: {
                        if (isOptional && maskChars[i] !== value[valuePos]) {
                            break;
                        }
                        if (maskChars[i] === value[valuePos]) {
                            if (options.onProcessInputChar) {
                                options.onProcessInputChar(value[valuePos], valuePos);
                            }
                            valuePos++;
                        }
                        if (options.onProcessFixedChar) {
                            options.onProcessFixedChar(maskChars[i]);
                        }
                        processedChars.push(new charDefs_1.FixedDef(maskChars[i]));
                    }
                }
            }
            return (options === null || options === void 0 ? void 0 : options.reverse) ? processedChars.reverse() : processedChars;
        };
        this._options = options;
        this.processedChars = [];
    }
    apply(value, options) {
        const processedChars = this.process(value, Object.assign(Object.assign({}, this.options), options));
        this.processedChars = processedChars;
        return {
            maskedValue: processedChars.map((char) => char.masked).join(''),
            unmaskedValue: processedChars.map((char) => char.unmasked).join(''),
        };
    }
    get maskedValue() {
        return this.processedChars.map((char) => char.masked).join('');
    }
    get unmaskedValue() {
        return this.processedChars.map((char) => char.unmasked).join('');
    }
    get options() {
        return this._options;
    }
    updateOptions(options) {
        this._options = Object.assign(Object.assign({}, this._options), options);
        const processedChars = this.process(this.processedChars.map((char) => char.masked).join(''), Object.assign({}, this._options));
        this.processedChars = processedChars;
        return {
            maskedValue: this.maskedValue,
            unmaskedValue: this.unmaskedValue,
        };
    }
}
exports.default = StringMask;
//# sourceMappingURL=mask.js.map